// // In src/reducers/loginReducer.js

// import {
//     LOGINAUTH,
//     LOGINULL,
//     CREATEUSER,
//     GET_ALL_USERS,
//     UPDATEUSER,
//     GETUSERBYROLL,
//     UPDATEUSERBYMOBAIL,
//     DELETEUSER,
//     LOGOUT
// } from '../actions/types';

// // Add isAuthenticated to the initial state
// const initialState = {
//     isAuthenticated: false, // <-- ADD THIS
//     loginData: null,
//     userList: [],
//     isLoggedIn: false,
//     username: null,
//     status: 0,
//     authToken: null, // Add other relevant properties here
//     role: null,
// };

// export default function (state = initialState, action) {
//     switch (action.type) {
//         case LOGINAUTH:
//             console.log("login payload");
//             console.log("login user", action.payload);
//             return {
//                 ...state,
//                 isAuthenticated: true, // <-- SET TO TRUE ON LOGIN
//                 loginData: action.payload,
//                 username: action.payload.data.username,
//                 id: action.payload.data.id,
//                 authToken: action.payload.data.token,
//                 hospitalID: action.payload.data.hospitalID,
//                 hospitalName: action.payload.data.hospitalName,
//                 hospitalLargeLogo: action.payload.data.hospitalLargeLogo,
//                 profileimage: action.payload.data.profileimage,
//                 Staffid: action.payload.data.Staffid,
//                 StaffRole: action.payload.data.role,
//                 role: action.payload.data.role,
//                 module: action.payload.data.module_names,
//                 Childrenmodule: action.payload.data.Childrenmodule_names,
//             };
       
//         case LOGOUT:
//             // This case now correctly resets the state
//             return {
//                 ...initialState, // A simple way to reset to the original state
//                 isLoggedIn: false,
//                 isAuthenticated: false, // <-- SET TO TRUE ON LOGIN


//             };
            
//         case LOGINULL:
//             // This should also be a full logout
//             return {
//                 ...initialState,
//                 isAuthenticated: false,
//                 status: action.payload,
//             };

//         // ... Your other cases remain the same ...
//         case CREATEUSER:
//             return {
//                 ...state,
//                 userSaveStatus: action.payload.success,
//                 userUpdateStatus: 0,
//             };
//         case GET_ALL_USERS:
//             return {
//                 ...state,
//                 userList: action.payload,
//             };
//         case GETUSERBYROLL:
//             return {
//                 ...state,
//                 userGetByRollData: action.payload.data,
//             };
//         case UPDATEUSER:
//             return {
//                 ...state,
//                 userGetData: action.payload.data,
//             };
//         case UPDATEUSERBYMOBAIL:
//             return {
//                 ...state,
//                 userUpdateData: action.payload.data,
//             };
//         case DELETEUSER:
//             return {
//                 ...state,
//                 userDeleteStatus: action.payload.data,
//             };
//         default:
//             return state;
//     }
// }















import {
    LOGINAUTH,
    LOGINULL,
    CREATEUSER,
    GET_ALL_USERS,
    UPDATEUSER,
    GETUSERBYROLL,
    UPDATEUSERBYMOBAIL,
    DELETEUSER,
    LOGOUT,
    GENERATE_CAPTCHA_SUCCESS,   // ✅ add karo
    GENERATE_CAPTCHA_ERROR 
} from '../actions/types';

// ============================================================
// LOGIN REDUCER
// Kya store karta hai:
//   - isAuthenticated: login hua ya nahi
//   - subscriptionStatus: 'active' ya 'inactive' (sidebar ke liye)
//   - app_status: 'enabled' ya 'disabled' (login block ke liye)
//   - role: 'Admin', 'Patient', 'superadmin'
// ============================================================

const initialState = {
    isAuthenticated: false,
    loginData: null,
    userList: [],
    isLoggedIn: false,
    username: null,
    status: 0,
    authToken: null,
    role: null,
    app_status: null,
    // ✅ YE NAI FIELDS HAIN — image ke flow ke liye
    subscriptionStatus: null,   // 'active' ya 'inactive' ya null
    subscriptionType: null,     // 'subscription' ya 'commission' ya null
     captchaImage: null,
    captchaId: null,
};

export default function (state = initialState, action) {
    switch (action.type) {

        // case LOGINAUTH:
        //      const userData = action.payload.data; 
        //     // Login success hone par sab kuch Redux mein save karo
        //     // action.payload.data mein server se jo bhi aata hai wo yahan store hoga
        //     return {
        //         ...state,
        //         isAuthenticated: true,
        //         loginData: action.payload,
        //         username: action.payload.data.username,
        //         id: action.payload.data.id,
        //         authToken: action.payload.data.token,
        //         hospitalID: action.payload.data.hospitalID,
        //         hospitalName: action.payload.data.hospitalName,
        //         hospitalLargeLogo: action.payload.data.hospitalLargeLogo,
        //         profileimage: action.payload.data.profileimage,
        //         Staffid: action.payload.data.Staffid,
        //         StaffRole: action.payload.data.role,
        //         role: action.payload.data.role,
        //          subscriptionStatus: userData.subscription_status || null,
        //         subscriptionType: userData.Subscription_type || null,
        //         appStatus: userData.app_status || 'enabled',
        //         module: action.payload.data.module_names,
        //         Childrenmodule: action.payload.data.Childrenmodule_names,
        //         // ✅ Server se directly subscription_status lo
        //         // DB mein ye field hoti hai — login response mein aati hai
        //         app_status: action.payload.data.app_status || 'enabled',
        //         subscriptionStatus: action.payload.data.subscription_status || null,
        //         subscriptionType: action.payload.data.Subscription_type || null,
        //     };
        // loginReducer.js - CHECK your LOGINAUTH case

case LOGINAUTH:
    const userData = action.payload.data;
    
    console.log('[Reducer] LOGINAUTH received:', {
        subscription_status: userData?.subscription_status,
        Subscription_type: userData?.Subscription_type
    });
    
    return {
        ...state,
        isAuthenticated: true,
        loginData: action.payload,
        username: userData?.username,
        id: userData?.id,
        authToken: userData?.token,
        hospitalID: userData?.hospitalID,
        hospitalName: userData?.hospitalName,
        hospitalLargeLogo: userData?.hospitalLargeLogo,
        profileimage: userData?.profileimage,
        Staffid: userData?.Staffid,
        StaffRole: userData?.role,
        role: userData?.role,
        // ✅ CRITICAL: Map correctly
        subscriptionStatus: userData?.subscription_status || 'inactive',
        subscriptionType: userData?.Subscription_type || null,
        appStatus: userData?.app_status || 'enabled',
        module: userData?.module_names,
        Childrenmodule: userData?.Childrenmodule_names,
    };

        case LOGOUT:
            // Logout par sab kuch reset
            return {
                ...initialState,
                isLoggedIn: false,
                isAuthenticated: false,
            };

        case LOGINULL:
            return {
                ...initialState,
                isAuthenticated: false,
                status: action.payload,
            };

        // ✅ YE NAA ACTION HAI — Plan purchase hone ke baad Redux update karo
        // PlanSelection.js dispatch karega ye action
        // case 'UPDATE_SUBSCRIPTION_STATUS':
        //     return {
        //         ...state,
        //         subscriptionStatus: action.payload.subscriptionStatus,
        //         subscriptionType: action.payload.subscriptionType,
        //     };
         case 'UPDATE_SUBSCRIPTION_STATUS':
            return {
                ...state,
                subscriptionStatus: action.payload.subscriptionStatus,
                subscriptionType: action.payload.subscriptionType,
            };

        case CREATEUSER:
            return {
                ...state,
                userSaveStatus: action.payload.success,
                userUpdateStatus: 0,
            };

        case GET_ALL_USERS:
            return {
                ...state,
                userList: action.payload,
            };

        case GETUSERBYROLL:
            return {
                ...state,
                userGetByRollData: action.payload.data,
            };

        case UPDATEUSER:
            return {
                ...state,
                userGetData: action.payload.data,
            };

        case UPDATEUSERBYMOBAIL:
            return {
                ...state,
                userUpdateData: action.payload.data,
            };

        case DELETEUSER:
            return {
                ...state,
                userDeleteStatus: action.payload.data,
            };
        case GENERATE_CAPTCHA_SUCCESS:
    console.log("[Reducer] Captcha payload received:", action.payload);
    return {
        ...state,
        captchaImage: action.payload.captchaImage,  // ✅ Use captchaImage
        captchaUuid: action.payload.captchaUuid,    // ✅ Use captchaUuid
    };

case GENERATE_CAPTCHA_ERROR:
    return {
        ...state,
        captchaImage: null,
        captchaUuid: null,
    };

        default:
            return state;
    }
}